import { __extends } from "tslib";
import { each, head, last } from '@antv/util';
import Continuous from './base';
/**
 * åæ®µåº¦é
 */
var Quantize = /** @class */ (function (_super) {
    __extends(Quantize, _super);
    function Quantize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'quantize';
        return _this;
    }
    Quantize.prototype.invert = function (value) {
        var ticks = this.ticks;
        var length = ticks.length;
        var percent = this.getInvertPercent(value);
        var minIndex = Math.floor(percent * (length - 1));
        // æåä¸ä¸ª
        if (minIndex >= length - 1) {
            return last(ticks);
        }
        // è¶åºå·¦è¾¹çï¼ ååç¬¬ä¸ä¸ª
        if (minIndex < 0) {
            return head(ticks);
        }
        var minTick = ticks[minIndex];
        var nextTick = ticks[minIndex + 1];
        // æ¯å½åå¼å°ç tick å¨åº¦éä¸çå æ¯
        var minIndexPercent = minIndex / (length - 1);
        var maxIndexPercent = (minIndex + 1) / (length - 1);
        return minTick + (percent - minIndexPercent) / (maxIndexPercent - minIndexPercent) * (nextTick - minTick);
    };
    Quantize.prototype.initCfg = function () {
        this.tickMethod = 'r-pretty';
        this.tickCount = 5;
        this.nice = true;
    };
    Quantize.prototype.calculateTicks = function () {
        var ticks = _super.prototype.calculateTicks.call(this);
        if (!this.nice) { // å¦æ nice = false ,è¡¥å min, max
            if (last(ticks) !== this.max) {
                ticks.push(this.max);
            }
            if (head(ticks) !== this.min) {
                ticks.unshift(this.min);
            }
        }
        return ticks;
    };
    // è®¡ç®å½åå¼å¨å»åº¦ä¸­çå æ¯
    Quantize.prototype.getScalePercent = function (value) {
        var ticks = this.ticks;
        // è¶åºå·¦è¾¹ç
        if (value < head(ticks)) {
            return 0;
        }
        // è¶åºå³è¾¹ç
        if (value > last(ticks)) {
            return 1;
        }
        var minIndex = 0;
        each(ticks, function (tick, index) {
            if (value >= tick) {
                minIndex = index;
            }
            else {
                return false;
            }
        });
        return minIndex / (ticks.length - 1);
    };
    return Quantize;
}(Continuous));
export default Quantize;
//# sourceMappingURL=quantize.js.map